import toDate from '../to-date';

export const subtractDays = (date: Date | number, amount: number): Date => {
  const formattedDate = toDate(date);

  formattedDate.setDate(formattedDate.getDate() - amount);

  return formattedDate;
};

export default subtractDays;
